import React, { createContext, useContext, useMemo, useState } from "react";

const ActiveContext = createContext(null);

export const ActiveContextProvider = ({ children }) => {
  const [currentOrganizationId, setCurrentOrganizationId] = useState(null);
  const [currentVesselId, setCurrentVesselId] = useState(null);
  const [currentVoyageId, setCurrentVoyageId] = useState(null);
  const [currentTripId, setCurrentTripId] = useState(null);
  const [selectedTripCargoId, setSelectedTripCargoId] = useState(null);

  const value = useMemo(
    () => ({
      currentOrganizationId,
      currentVesselId,
      currentVoyageId,
      currentTripId,
      selectedTripCargoId,
      setCurrentOrganizationId,
      setCurrentVesselId,
      setCurrentVoyageId,
      setCurrentTripId,
      setSelectedTripCargoId,
      resetActiveContext: () => {
        setCurrentOrganizationId(null);
        setCurrentVesselId(null);
        setCurrentVoyageId(null);
        setCurrentTripId(null);
        setSelectedTripCargoId(null);
      },
    }),
    [
      currentOrganizationId,
      currentVesselId,
      currentVoyageId,
      currentTripId,
      selectedTripCargoId,
    ]
  );

  return <ActiveContext.Provider value={value}>{children}</ActiveContext.Provider>;
};

export const useActiveContext = () => {
  const context = useContext(ActiveContext);

  if (!context) {
    throw new Error("useActiveContext must be used within ActiveContextProvider");
  }

  return context;
};
